import { renderToStaticMarkup } from "react-dom/server";
import GenericButtonPreview from "../components/GenericButtonPreview";
import type Device from "./Device";
import type { BaseButtonProps } from "./BaseDeviceProps";

/** A data URL can be used by the existing image and PDF consumers. */
export function genericFrontImage(params: BaseButtonProps, device: Device | undefined): string | undefined {
  const svg = renderToStaticMarkup(<GenericButtonPreview params={params} device={device} />);
  return svg ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}` : undefined;
}
